<template>
  <footer :class="getClassName('cart-footer')">
    <dl :class="getClassName('cart-footer__total')" v-if="items.length > 0">
      <dt :class="getClassName('cart-footer__term')">
        商品合計<span :class="getClassName('cart-footer__ruby')">(税込)</span>
      </dt>
      <dd :class="getClassName('cart-footer__price')">
        <span :class="getClassName('cart-footer__strong')">{{ getTotal }}</span
        >円
      </dd>
    </dl>
    <div :class="getClassName('cart-footer__box')">
      <a :class="getClassName('cart-footer__button--order')" :href="orderUrl" v-if="items.length > 0"
        >購入手続きへ</a
      >
      <a :class="getClassName('cart-footer__button--continue')" :href="'/items'">お買いものを続ける</a>
    </div>
  </footer>
</template>

<script>
import { numberFormat } from '../../../_modules/util';

import getClassName from '../../_mixins/getClassName';

export default {
  mixins: [getClassName],
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    orderUrl: {
      type: String,
      required: true,
      default: '',
    },
    media: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    getTotal() {
      return numberFormat(this.items.reduce((prev, value) => prev + value.price * value.quantity, 0));
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../_sass/variables';

.cart-footer {
  padding-top: 20px;
  border-top: solid 1px currentcolor;
  margin-top: 10px;
  &--sp {
    margin-top: 0;
  }
  &__total {
    line-height: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    &--sp {
      width: 280px;
      margin-left: auto;
      justify-content: space-between;
    }
  }
  &__term {
    font-size: 1.5rem;
  }
  &__ruby {
    font-size: 1.3rem;
  }
  &__price {
    min-width: 140px;
    margin-left: 20px;
    color: $color__price;
    text-align: right;
    &--sp {
      min-width: auto;
      min-width: initial;
    }
  }
  &__strong {
    font-size: 2.6rem;
    font-weight: bold;
  }
  &__box {
    width: 741px;
    margin: 20px auto 0;
    display: flex;
    justify-content: center;
    &--sp {
      width: 100%;
      display: block;
    }
  }
  %button {
    width: 360px;
    height: 58px;
    border-radius: 29px;
    font-size: 1.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  %button--sp {
    width: 100%;
    height: 50px;
    border-radius: 25px;
    font-size: 1.8rem;
  }
  &__button--order {
    @extend %button;
    order: 2;
    background: $color__price;
    margin-left: 20px;
    color: #fff;
    &--sp {
      @extend %button--sp;
      margin: 0 0 40px;
    }
  }
  &__button--continue {
    @extend %button;
    order: 1;
    background: #fff;
    border: 1px solid $color__price;
    color: $color__price;
    &--sp {
      @extend %button--sp;
    }
  }
}
</style>
